import { render, staticRenderFns } from "./KnowBaseList.vue?vue&type=template&id=e0d168d0&scoped=true"
import script from "./KnowBaseList.vue?vue&type=script&lang=js"
export * from "./KnowBaseList.vue?vue&type=script&lang=js"
import style0 from "./KnowBaseList.vue?vue&type=style&index=0&id=e0d168d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d168d0",
  null
  
)

export default component.exports